import { create } from "zustand";

export type ExecutionStatusTab =
  | "all"
  | "running"
  | "succeeded"
  | "failed";

type ExecutionsUiState = {
  statusFilter: ExecutionStatusTab;
  workflowFilter: string;
  setStatusFilter: (value: ExecutionStatusTab) => void;
  setWorkflowFilter: (value: string) => void;
};

export const useExecutionsUiStore = create<ExecutionsUiState>((set) => ({
  statusFilter: "all",
  workflowFilter: "",
  setStatusFilter: (value) => set({ statusFilter: value }),
  setWorkflowFilter: (value) => set({ workflowFilter: value }),
}));
